module.exports = ["human","gradient","robot","iot","robot","health","polici","5g","ai","gdpr","neural_network","deep_learn","convolut_neural","machin_learn","machin_translat","comput_vision","speech_recognit","object_detect","iot_devic","edg_comput","iot_network","augment_realiti","hate_speech","privaci_rule","mix_realiti","digit_transform"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/words_arxiv.json
// module id = RlWM
// module chunks = 1